import React from 'react';

const CampaignHypherlink = props => {
	const { redirectURL, campaignText } = props.campaign;

	return (
		<a className="campaign-hypherlink" target="_blank" href={redirectURL} rel="noreferrer">
			<span>{campaignText}</span>
		</a>
	);
};

export default CampaignHypherlink;
